import { connect } from 'react-redux'
import StationUserForm from '../../components/station-user/form/StationUserForm'
import { updateStationUser, fetchStationUser, createStationUser } from '../../state/actions/station-user/index'
import { getCurrentOrganization } from '../../state/reducers/organizations'
import { IStationUserInvite, IStoreState, IOrganizationTeamMember, IStationUserUpdateDTO } from '../../types/index'
import { buildOrganizationTeamMember } from 'src/state/selectors'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const selectedOrg = getCurrentOrganization(state)
  const matchedId = ownProps.match.params.id
  const currentStationUser = state.stationUser.items[matchedId]
  return {
    stationUserId: matchedId,
    currentStationUser,
    selectedOrg,
    organizations: state.organizations.items,
    processing: state.stationUser.isProcessing,
    fetching: state.stationUser.isFetching
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSubmit: (stationUser: IStationUserInvite) => {
      return dispatch(createStationUser(stationUser))
    },
    onUpdate: (stationUser: IStationUserUpdateDTO) => {
      return dispatch(updateStationUser(stationUser))
    },
    fetchTeamMember: (id: string) => {
      return dispatch(fetchStationUser(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationUserForm)



// WEBPACK FOOTER //
// ./src/containers/station-user/StationUserCreateForm.ts